import { Button, Typography } from '@mui/material'
import {
  ConfirmationWrapp, Card, Container, ActionArea, MovementsList,
} from './ReplacemenConfirmation.styles'

export interface MovimentationCardProps {
  description: string
  quantity: number
  expirationDate: string
  inputAddress: string
}

export interface ReplacementConfirmationProps {
  movimentations: MovimentationCardProps[]
  onCancel: () => void
  onConfirm: () => void
  onFinish?: () => void
  hasError?: boolean
  disabledConfirmButton?: boolean
}

export const ReplacementConfirmation = ({
  movimentations, onCancel, onConfirm, hasError, onFinish, disabledConfirmButton,
}: ReplacementConfirmationProps) => {
  const movimentationsCount = movimentations.length
  const resolveTitleEnd = movimentationsCount > 1 ? 'dos lotes' : 'do lote'
  const title = hasError ? 'Verifique os itens da movimentação' : `Deseja confirmar a movimentação ${resolveTitleEnd}?`

  return (
    <ConfirmationWrapp data-testid='confirmation-modal'>
      <Container>
        <Typography variant='h5'>{title}</Typography>
        <MovementsList data-testid='movements-list' listSize={movimentationsCount}>
          {
            movimentations.map((movimentation, index) => (
              <Card key={index}>
                <div>
                  Produto: <b>{movimentation.description}</b>
                </div>
                <div>
                  Data de validade: <b>{movimentation.expirationDate}</b>
                </div>
                <div>
                  Quantidade: <b>{movimentation.quantity}</b>
                </div>
                <div>
                  Movimentado para: <b>{movimentation.inputAddress}</b>
                </div>
              </Card>
            ))
          }
        </MovementsList>
        <ActionArea hasError={hasError}>
          {hasError
            ? (
              <Button variant='contained' onClick={onFinish} data-testid='finish-movement-button'>
                Finalizar
              </Button>
            )
            : (
              <>
                <Button variant='contained' onClick={onConfirm} data-testid='confirm-movement-button' disabled={disabledConfirmButton === true}>
                  Confirmar
                </Button>
                <Button variant='contained' color='error' onClick={onCancel} data-testid='cancel-movement-button'>
                  Cancelar
                </Button>
              </>
            )}
        </ActionArea>
      </Container>
    </ConfirmationWrapp>
  )
}
